import {
    LOG_IN,
    LOG_OUT,
    LOG_OUT_SUCCESS,
    CANCEL_LOGIN_DIALOG,
    SESSION_INITIALIZED,
    EXTEND_SESSION,
    LOG_IN_SUCCESS,
    CHANGE_PASSWORD,
    CHANGE_PASSWORD_SUCCESS,
    ACTIVATE_ACCOUNT,
    EXTEND_SESSION_SUCCESS,
    RESET_USER_PASSWORD_SUCCESS, FORGOT_PASSWORD, RESET_USER_PASSWORD,

} from './SessionActionTypes';
import {iif, Observable} from 'rxjs';
import { flatMap, switchMap, map, catchError, delay, mapTo, takeUntil, filter } from 'rxjs/operators';

import { combineEpics } from 'redux-observable';
import config from 'react-global-configuration';
import {push} from 'connected-react-router';
import {sessionSelectors, sessionActions} from './'
import {
    errorHandlingWithLogoutCheck, errorMessage,
    getJsonWithAuth, getJsonWithBasicAuth,
    postJsonWithBasicAuth,
    putJsonWithAuth, putJsonWithBasicAuth
} from "../../../components/AjaxHelpers";
import {globalActions} from "../../global/redux";
import {ajax} from "rxjs/ajax";

const errorHandlingForChangePasswordNotLoggedIn = (error, errorAction, alternateErrorMessage) => {
    console.log(error)
    if (error.status === 401) {
        errorAction[0].errorMessage =
            "Lösenordet kunde inte bytas, det kan bero på att giltighetstiden på din begäran om lösenordsbyte har gått ut.";
    } else {
        errorAction[0].errorMessage = errorMessage(error, alternateErrorMessage);
    }
    return errorAction;
}

export const sessionEpics = combineEpics(

    (action$, state$) => action$.ofType(CANCEL_LOGIN_DIALOG).pipe(
        flatMap(action => ([push('/'), sessionActions.closeLoginDialog()]))
    ),

    (action$, state$) => action$.ofType(ACTIVATE_ACCOUNT).pipe(
        switchMap(action =>
            postJsonWithBasicAuth({
                url: config.get('apiBaseUrl') + '/auth/v1/activate',
                body: {
                    username: action.username,
                    currentPassword: action.oneTimePassword,
                    newPassword: action.newPassword,
                    newPasswordRetype: action.newPasswordRetype,
                },
                username: action.username,
                password: action.oneTimePassword
            }).pipe(
                map(responseContainer => sessionActions.activationSucceeded(responseContainer.response.accessToken, action.username, responseContainer.response.expiresUTC)),
                catchError(error => [sessionActions.activationFailed(error)])
            )
        )
    ),

    // Events of type LOG_IN
    (action$, state$) => action$.ofType(LOG_IN).pipe(
        switchMap(action =>
            getJsonWithBasicAuth({
                    url: config.get('apiBaseUrl') + '/auth/v1/token',
                    username: action.username,
                    password: action.password
            }).pipe(
                map(payload => sessionActions.logInSucceeded(payload.accessToken, action.username, payload.expiresUTC)),
                catchError(payload => [sessionActions.logInFailed(payload)])
            )
        )
    ),

    // LOG_IN_SUCCESS is triggered by the session menu on manual logins, move the user to the start page
    (action$, state$) => action$.ofType(LOG_IN_SUCCESS).pipe(
        // delay(150),
        filter(action => action.auth.roles[0].replace('ROLE_','') === 'ADMIN'),
        flatMap(action => ([push('/vardenheter'), sessionActions.closeLoginDialog()]))
    ),

    (action$, state$) => action$.ofType(LOG_IN_SUCCESS).pipe(
        // delay(150),
        filter(action => action.auth.roles[0].replace('ROLE_','') === 'CARE_UNIT'),
        flatMap(action => ([push('/optiker'), sessionActions.closeLoginDialog()]))
    ),

    (action$, state$) => action$.ofType(LOG_IN_SUCCESS).pipe(
        // delay(150),
        filter(action => action.auth.roles[0].replace('ROLE_','') === 'OPTICIAN'),
        flatMap(action => ([push('/remiss'), sessionActions.closeLoginDialog()]))
    ),

    // SESSION_INITIALIZED is triggered by the session menu both on manual logins and autmoatic extensions, move the user to the start page
    (action$, state$) => action$.ofType(SESSION_INITIALIZED).pipe(
        // delay(150),
        filter(action => action.roles[0].replace('ROLE_','') === 'CHANGE_PASSWORD'),
        flatMap(action => ([push('/bytlosenord'), sessionActions.closeLoginDialog()]))
    ),

    (action$, state$) => action$.ofType(EXTEND_SESSION).pipe(
        switchMap(action =>
            getJsonWithAuth({
                url:config.get('apiBaseUrl') + '/auth/v1/token',
                state: state$.value
            }).pipe(
                map(payload => sessionActions.extendSessionSucceeded(payload.accessToken, sessionSelectors.loggedInUser(state$.value), payload.expiresUTC)),
                catchError(response => errorHandlingWithLogoutCheck(response, [sessionActions.logInFailed(response)]))
            )
        )
    ),

    (action$, state$) => action$.ofType(LOG_OUT).pipe(
        delay(500),
        flatMap(action => ([sessionActions.logOutSucceeded(action.username)]))
    ),

    (action$, state$) => action$.ofType(LOG_OUT_SUCCESS).pipe(
        flatMap(action => ([push('/')]))
    ),

    // Send log out event when the session (access token) expires
    (action$, state$) => action$.pipe(
        // Create a new automatic log out time on both manual login and automatic session extensions
        filter((action) => (action.type === LOG_IN_SUCCESS || action.type === EXTEND_SESSION_SUCCESS) && sessionSelectors.loggedInUser(state$.value)),
        switchMap(action =>
            Observable.create(obs => {
                // create a fake observable to delay on
                obs.next([1,]);
                obs.complete();
            }).pipe(
                delay(Math.max(1, (new Date(sessionSelectors.expiresUTC(state$.value)).valueOf() - new Date().valueOf()))),
                mapTo(sessionActions.logOut()),
                takeUntil(action$.ofType(EXTEND_SESSION, LOG_OUT, LOG_OUT_SUCCESS)) //until logged out or the session is extended
            )
        )
    ),

    (action$, state$) => action$.ofType(CHANGE_PASSWORD).pipe(
        switchMap(action =>
            // if the new and new retype password are equal we map the putJson observable
            // otherwise we map a password change failure observable
            iif (
                () => (action.newPassword === action.newPasswordRetype),
                iif(()=>action.loggedInUser,
                putJsonWithAuth({
                    url: config.get('apiBaseUrl') + '/me/v1/password',
                    body: {
                        currentPassword: action.currentPassword,
                        newPassword: action.newPassword,
                        newPasswordRetype: action.newPasswordRetype,
                    },
                    state: state$.value
                }).pipe(
                    map(payload => sessionActions.changePasswordSucceeded(payload)),
                    catchError(error => errorHandlingWithLogoutCheck(error, [sessionActions.changePasswordFailed(error)]))
                ),
                    putJsonWithBasicAuth({
                        url: config.get('apiBaseUrl') + '/me/v1/password',
                        username: action.username,
                        password: action.currentPassword,
                        body: {
                            // currentPassword: action.currentPassword,
                            newPassword: action.newPassword,
                            newPasswordRetype: action.newPasswordRetype,
                        },
                        state: state$.value
                    }).pipe(
                        map(payload => sessionActions.changePasswordSucceeded(payload)),
                        catchError(error => errorHandlingForChangePasswordNotLoggedIn(error, [sessionActions.changePasswordFailed(error)]))
                    ),
                    ),
                Observable.create(obs => {
                    // create an observable to emit the changePasswordFailed
                    obs.next([1,]);
                    obs.complete();
                }).pipe(
                    flatMap(action => ([sessionActions.changePasswordFailed("Lösenorden stämmer ej överens")]))
                )
            )

        )
    ),

    (action$, state$) => action$.ofType(FORGOT_PASSWORD).pipe(
        flatMap(action =>
            iif(() => (action.email && typeof action.email === 'string' && action.email !== ''),
                [push('/glomt#email='+action.email)],
                [push('/glomt')]
        ))
    ),

    (action$, state$) => action$.ofType(RESET_USER_PASSWORD).pipe(
        switchMap(action =>
            // Get json without auth, i.e. unauthenticated/anonymous
            ajax.getJSON(config.get('apiBaseUrl') + '/user/v1/users/' + action.email + '/passwordReset').pipe(
                map(payload => sessionActions.resetUserPasswordSuccess()),
                catchError(error => errorHandlingWithLogoutCheck(error,
                    [sessionActions.resetUserPasswordFailed(error)],
                    "Något gick fel när lösenordet skulle nollställas."))
            )
        )
    ),

    (action$, state$) => action$.ofType(RESET_USER_PASSWORD_SUCCESS).pipe(
        flatMap(action => ([globalActions.globalInfo("Ett mail med information hur du nollställer ditt lösenord har skickats till din mailadress."),push('/')]))
    ),

    (action$, state$) => action$.ofType(CHANGE_PASSWORD_SUCCESS).pipe(
        flatMap(action => ([globalActions.globalInfo("Lösenordet uppdaterades"),push('/')]))
    )

);